import type { EmployeeHomeBalance, EmployeeHomeViewer, EmployeeHomeWorker } from './model';

const impersonatedWorkerNames: Readonly<Record<string, string>> = {
  '01': '정성진',
  '02': '우디(박진우)',
  '03': '김민서',
  '04': '이수연',
  '05': '한도윤',
  '06': '강예린',
  '07': '장우진',
};

export function fixtureEmployeeHomeWorker(viewer: EmployeeHomeViewer): EmployeeHomeWorker {
  if (!viewer.impersonating) return { displayName: '이정연' };
  return { displayName: viewer.workerId ? impersonatedWorkerNames[viewer.workerId] ?? '이정연' : '이정연' };
}

export const fixtureEmployeeHomeBalances: readonly EmployeeHomeBalance[] = [{
  label: '연차 휴가',
  asOf: '2026-08-15',
  balance: '11.5',
  accrued: '15',
  carryOver: '2',
  used: '5.5',
}];
